export enum ERole {
  EXAMINER = 'EXAMINER',
  REGISTRAR = 'REGISTRAR',
  CHIEF_REGISTRAR = 'CHIEF_REGISTRAR',
  DEPUTY_CHIEF_REGISTRAR = 'DEPUTY_CHIEF_REGISTRAR',
  CONVEYANCER = 'CONVEYANCER',
  ADMIN = 'ADMIN',
  CITIZEN = 'CITIZEN',
  LAWYER = 'LAWYER',
  LAW_FIRM_ADMIN = 'law firm admin',
  ASSOCIATION_ADMIN = 'ASSOCIATION_ADMIN',
  MEMBER_ADMIN = 'MEMBER_ADMIN',
  REGULAR_USER = 'REGULAR_USER',
  NOTARY = 'NOTARY',
  HIGH_COURT_ADMIN = 'HIGH_COURT_ADMIN',
  LOCAL_GOV = 'LOCAL_GOV',
  MINISTRY_OF_LAND = 'MINISTRY_OF_LAND',
  LOCAL_GOVERNMENT_TECHNICIAN = 'LOCAL_GOVERNMENT_TECHNICIAN',
  LOCAL_GOVERNMENT_ESTATE_OFFICER = 'LOCAL_GOVERNMENT_ESTATE_OFFICER',
  LOCAL_GOVERNMENT_ACCOUNTANT = 'LOCAL_GOVERNMENT_ACCOUNTANT',
  LOCAL_GOVERNMENT_DIRECTOR = 'LOCAL_GOVERNMENT_DIRECTOR',
  DEEDS_ACCOUNTANT = 'DEEDS_ACCOUNTANT',
  SURVEYOR_GENERAL_ACCOUNTANT = 'SURVEYOR_GENERAL_ACCOUNTANT',
  SURVEYOR_GENERAL_TECHNICIAN = 'SURVEYOR_GENERAL_TECHNICIAN',
  SURVEYOR_GENERAL = 'SURVEYOR_GENERAL',
  REGISTRY = 'REGISTRY',
  FINANCE_OFFICER = 'FINANCE_OFFICER',
  MINISTER_OF_LANDS_TECHNICIAN = 'MINISTER_OF_LANDS_TECHNICIAN',
  MINISTER_OF_LANDS_DIRECTOR = 'MINISTER_OF_LANDS_DIRECTOR',
  MINISTER_OF_LANDS_DIRECTOR_LEGAL = 'MINISTER_OF_LANDS_DIRECTOR_LEGAL',
  DB_ADMIN = 'DB_ADMIN',
  DB_ADMIN_FARMS = 'DB_ADMIN_FARMS',
  CHIEF_ACCOUNTANT = 'CHIEF_ACCOUNTANT',
  DATA_CAPTURER = 'DATA_CAPTURER',
  PRODUCT_OWNER = 'PRODUCT_OWNER',
  FIRST_BANK_USER = 'FIRST_BANK_USER',
  SECOND_BANK_USER = 'SECOND_BANK_USER',
  BANK_ADMIN = 'BANK_ADMIN',
}
